<script lang="ts">

    import { Icon, InputGroup, InputGroupText } from "sveltestrap";
    import type { Question } from "../../Model/Question";
    import { getContext } from "svelte";
    import type { GetAnswerFn, SaveAnswerFn } from "../../global";
    import type { Answer } from "../../Model/Answer";
    import { debounce } from "../../Services";
    import type { Readable } from "svelte/store";
    import QuestionHeader from "./QuestionHeader.svelte";
    import AlertSaveError from "../AlertSaveError.svelte";

    export let question: Question;

    const saveDebounce = debounce(500);
    const getAnswer: GetAnswerFn = getContext('getAnswer');
    const readonlyForm: Readable<boolean> = getContext('readonlyForm');
    const saveAnswer: SaveAnswerFn = getContext('saveAnswer');

    let isSaving = false;
    let saveError = false;
    let answer: Answer;
    let value: Readable<any>;
    let input: HTMLInputElement;
    
    $: setupQuestion(question);

    function setupQuestion(question: Question): void {
        answer = getAnswer(question.id);
        value = answer.valueReadable;
    }

    function onInput(): void {
        if (!answer || $readonlyForm) {
            return;
        }
        answer.value = input.value;
        saveDebounce(realSaveAnswer);
    }

    async function realSaveAnswer() {
        if (!answer) {
            return;
        }
        try {
            isSaving = true;
            await saveAnswer(answer);
            saveError = false;
        } catch (error) {
            saveError = true;
        } finally {
            isSaving = false;
        }
    }

</script>

<QuestionHeader {question} />

<InputGroup>
    <input
        bind:this={input}
        class="form-control"
        type="date"
        readonly={$readonlyForm}
        value={$value}
        disabled={isSaving}
        on:input={onInput} />
    {#if saveError}
        <AlertSaveError />
    {/if}
</InputGroup>
